<template>
  <div>
    <v-app-bar
      dense
      flat
      height="50"
    >
      <v-row align="center">
        <v-col
          xs="12"
          sm="5"
          md="4"
          class="d-none d-sm-flex"
        >
          <search-field
            :search-text="searchText"
            :status="status"
            @statusChange="changeStatus"
            @search="onSearch"
          />            
        </v-col>
        <v-col
          xs="12"
          sm="7"
          md="8"
          align="end"
        >
          <v-btn
            id="role_refresh"
            color="primary"
            :loading="loader"
            class="mr-2 elevation-0"
            @click.native="reload()"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <create-form
            :role-id="selectedRoleId"
            :open.sync="roleForm"
            @refresh="reload"
          />
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                id="role_add"
                slot="activator"
                class="elevation-0"
                color="success"
                @click="openRoleForm()"
                v-on="on"
              >
                <v-icon>mdi-plus</v-icon> Role
              </v-btn>
            </template>
            <span>Create a new role</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-app-bar>
    <v-card
      flat
      outlined
      tile
    >
      <v-card-text>
        <v-row>
          <v-col
            xs="12"
            class="d-flex d-sm-none"
          >
            <search-field
              :search-text="searchText"
              :status="status"
              @statusChange="changeStatus"
              @search="onSearch"
            />            
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-divider></v-divider>
        </v-row> -->
        <v-row>
          <v-col
            v-for="role in roles"
            :key="`role-list--${role.id}`"
            cols="12"
            sm="4"
            lg="3"
            xl="2"
          >
            <v-card
              class="mx-auto"
              flat
              outlined
            >
              <v-card-text
                style="cursor: pointer"
                @click="openRoleForm(role.id)"
              >
                <v-row justify="end">
                  <v-col cols="auto">
                    <role-options
                      :role-id="role.id"
                      :active="role.activeStatus"
                      @reload="getRoles()"
                    />
                  </v-col>
                </v-row>
                <v-row
                  class="text-center"
                  no-gutters
                >
                  <v-col
                    cols="12"
                    class="text-h5"
                  >
                    {{ role.name }}
                  </v-col>
                  <v-col v-show="role.privilegeNames && role.privilegeNames.length">
                    <v-menu
                      open-on-hover
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          text
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon
                            left
                            small
                          >
                            mdi-star-cog
                          </v-icon>
                          <span class="text-decoration-underline">
                            privileges</span>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item
                          v-for="privilege in role.privilegeNames"
                          :key="`privilege-names--${privilege}`"
                        >
                          <v-list-item-title>
                            {{ privilege }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider class="mt-2 mx-4" />

              <v-card-actions>
                <v-row justify="center">
                  <v-col cols="auto">
                    <v-chip
                      v-if="role.activeStatus"
                      outlined
                      label
                      color="success--text"
                    >
                      Active
                    </v-chip>
                    <v-chip
                      v-else
                      outlined
                      label
                      color="error--text"
                    >
                      In-active
                    </v-chip>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-show="totalPage > 1">
        <v-row>
          <v-col>
            <v-pagination
              v-model="page"
              :length="totalPage"
              @input="getRoles()"
            />
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { failure, pagination } from "@/mixins/common";
import RoleOptions from "@/components/user/role/RoleOptions";
import CreateForm from "@/components/user/role/RoleForm";
import SearchField from "@/components/utils/SearchField";

export default {
  name: "RoleList",
  components: {
    RoleOptions,
    CreateForm,
    SearchField
  },
  mixins: [failure, pagination],
  data() {
    return {
      loader: false,
      roles: [],
      searchText: null,
      page: 1,
      totalPage: 0,
      status: "",
      roleForm: false,
      selectedRoleId: 0
    };
  },
  created() {
    this.init();
  },
  methods: {
    getRoles() {
      this.loader = true;
      let url = `${this.ADMIN_API_URL}/roles?page=${
        this.page - 1
      }&sort_key=name&limit=${this.limit}&status=${this.status}`;
      if (this.searchText) {
        url += `&search=${this.searchText}`;
      }
      this.$http.get(url).then(
        (res) => {
          this.roles = res.body.data || [];
          this.totalPage = res.body.totalPage;
          this.page = res.body.pagination.page + 1;
          this.loader = false;
        },
        (failure) => {
          this.handleFailure(failure);
        }
      );
    },
    search() {
      this.page = 1;
      this.getRoles();
    },
    reload() {
      this.searchText = null;
      this.status = "";
			this.search();
		},
    onSearch(val) {
      this.searchText = val;
      if (!val || val.length >= 3) {
        this.search();
      }
    },
		changeStatus(status) {
			this.status = status;
			this.search();
    },
    openRoleForm(id = 0) {
      this.selectedRoleId = id;
      this.roleForm = true;
    },

    init() {
      this.getRoles();
    }
  }
};
</script>
